import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Collapse, Paper } from "@mui/material";
import isUndefined from "lodash.isundefined";
import React from "react";
import { useUpdateEffect } from "react-use";
import { CollapseHeader } from "./CollapseHeader.js";
import { CollapseTitle } from "./CollapseTitle.js";
import { LoadingSpinner } from "./loading/LoadingSpinner.js";
export const CardContainer = React.forwardRef(({ id, Icon, title, tabs, isExpandable: isExpandableProp, isInitiallyClosed, CollapsedHint, itemCount, ActionButton, isSelected = false, disableAutoExpand = false, isLoading = false, titleVariant, children, }, ref) => {
    const isExpandable = isExpandableProp ?? itemCount !== undefined;
    const [isExpanded, setIsExpanded] = React.useState(!isExpandable
        ? true
        : !isUndefined(isInitiallyClosed)
            ? !isInitiallyClosed
            : !isUndefined(itemCount)
                ? itemCount && itemCount > 0
                    ? true
                    : false
                : true);
    useUpdateEffect(() => {
        if (!isExpandable || disableAutoExpand)
            return;
        if (itemCount && itemCount > 0) {
            setIsExpanded(true);
        }
        else if (itemCount === 0) {
            setIsExpanded(false);
        }
    }, [itemCount]);
    const Title = title ? (_jsx(CollapseTitle, { title: title, icon: Icon, count: itemCount, variant: titleVariant })) : undefined;
    return (_jsxs(Paper, { id: id, ref: ref, sx: isSelected ? { boxShadow: "inset 0 0 0 2px #377dc3" } : {}, children: [Title || tabs ? (_jsx(CollapseHeader, { isExpandable: isExpandable, isExpanded: isExpanded, setIsExpanded: setIsExpanded, title: Title, tabs: tabs, ActionButton: ActionButton, CollapsedHint: CollapsedHint, px: 1 })) : null, isLoading ? (isExpanded && _jsx(LoadingSpinner, { padding: 1 })) : (_jsx(Collapse, { in: isExpanded, children: children }))] }));
});
//# sourceMappingURL=CardContainer.js.map